import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import {
  isGlobalConnectFinland,
  isGlobalConnectSweden,
} from '../utils/communication-operator.util';

export const SwedishPortalGuard: CanMatchFn = () => {
  const router = inject(Router);

  return isGlobalConnectSweden() ? true : router.parseUrl('/hoppsan');
};

export const FinnishPortalGuard: CanMatchFn = () => {
  const router = inject(Router);

  return isGlobalConnectFinland() ? true : router.parseUrl('/hoppsan');
};
